import { render, staticRenderFns } from "./DigiLearningStyleBViewer.vue?vue&type=template&id=7e8ab988&"
import script from "./DigiLearningStyleBViewer.vue?vue&type=script&lang=js&"
export * from "./DigiLearningStyleBViewer.vue?vue&type=script&lang=js&"
import style0 from "./DigiLearningStyleBViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports